module.exports = __webpack_public_path__ + "img/collection-engagementRingsModern@2x.b9af181.webp";